import { platformService } from '@monthio/react-components'
import Cookies from 'js-cookie'
import { resolveAndExecuteReceiverResolver } from './receiverResolver'
import configuration from '../../config'

const redirectApplicantIdCookieName = 'monthio_redirect_applicant_id'

export const redirectToFlow = (applicantId?: string, consentCode?: string) => {
	const flowUrl =
		`${platformService.getClientUrl(
			'smartcheckFlowClient',
		)}?sessionId=${applicantId}` +
		(consentCode ? `&consentCode=${consentCode}` : '')

	window.location.replace(flowUrl)
}

export const hasParentWindow: boolean =
	window.opener && window.opener !== window

export const handleRedirect = async () => {
	const receiverResult = await resolveAndExecuteReceiverResolver(
		window.location.pathname,
	)

	if (receiverResult.success) {
		if (hasParentWindow) {
			window.close()
			return
		}

		const redirectApplicantIdCookie = Cookies.get(redirectApplicantIdCookieName)
		const applicantId = receiverResult.applicantId
			? receiverResult.applicantId
			: redirectApplicantIdCookie

		if (!applicantId) {
			throw new Error('ApplicantId not found')
		}

		// If the redirect cookie is not found, we can't redirect to the flow.
		// Instead, stuck page is displayed
		if (redirectApplicantIdCookie === undefined) {
			window.location.pathname = configuration.routeCodes.bankAddedSuccessfully
			return
		}

		redirectToFlow(applicantId, receiverResult.consentCode)
	}
}
